import React from "react";
import clsx from "clsx";

class BookingButtonPresenterNoAvailability extends React.Component {

  constructor(props) {
    super(props); 
  };

  render() {
    var tabClasses = clsx({
			'active': this.props.active_tab == 'no_availability',
			'tab-pane': true,
    })
    
    return (
      <div className={tabClasses} id="no_availability">
        <div className="col-md-12">
            <div className="form-group no-rooms-available">
              <label>{I18n.t('no_availability_text')}</label>
              <br />
                <div className="no-availability-text" dangerouslySetInnerHTML={{__html: this.props.no_availability_text}}></div>
            </div>
          </div>
      </div>
    )
  }
}

export default BookingButtonPresenterNoAvailability